module.exports = __webpack_public_path__ + "img/consul-02z.9a3fed81.jpg";